  import axios from 'axios';
  import { API } from '../api';
  import { getAccessToken } from './authService'; // Импорт функции для получения токена

  // Функция для получения данных определенной строки определенного поля в таблице
  export const fetchTableFieldData = async (endpoint, id, field) => {
    try {
      const token = getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }

      // Запрос к API с популяцией поля (компонента)
      const response = await axios.get(`${API.BASE_URL}/getComponent/${id}?table=${endpoint}&component=${field}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Проверяем, если поле существует в данных ответа
      if (response.data && response.data.component && response.data.scheme) {
        const fieldData = response.data.component;
        const scheme = response.data.scheme;

        // Если данные компонента найдены, возвращаем их вместе со схемой
        if (fieldData) {
          return { component: fieldData, scheme };
        } else {
          throw new Error(`Field '${field}' not found in response data`);
        }
      }

      throw new Error('Invalid response structure');
    } catch (error) {
      console.error(`Error fetching field data from ${endpoint} for id ${id}, field ${field}:`, error);
      throw error;
    }
  };



  export const fetchTableData = async (endpoint, page = 1, pageSize = 10, searchQuery = '', searchField = 'name') => {
    try {
      const token = getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }

      const params = {
        'pagination[page]': page, // Номер текущей страницы
        'pagination[pageSize]': pageSize, // Количество записей на странице
        'populate': '*', // Популяция данных
      };

      // Добавляем фильтрацию, если она нужна
      if (searchQuery && searchField) {
        params[`filters[${searchField}][$contains]`] = searchQuery; // Поиск по определенному полю
      }

      const response = await axios.get(`${API.BASE_URL}/${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params,
      });

      return response.data;
    } catch (error) {
      console.error(`Error fetching data from endpoint ${endpoint}:`, error);
      return { data: [], meta: { pagination: { total: 0 } } }; // Возвращаем структуру, чтобы избежать ошибок
    }
  };





  export const deleteTableRecord = async (endpoint, id) => {
    try {
      const token = getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }

      const response = await axios.delete(`${API.BASE_URL}/${endpoint}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error(`Error deleting record from ${endpoint}:`, error);
      throw error;
    }
  };


  export async function getTranslation(field) {
    try {
      // Make a request to the backend to get the translation
      const response = await fetch(`${API.BASE_URL}/perevods?filters[english][$eq]=` + field);
      const data = await response.json();

      // If a translation is found, return the Russian version
      if (data.data.length > 0) {
        return data.data[0].attributes.russian;
      }

      // If no translation is found, return the original field name
      return field;
    } catch (error) {
      console.error('Error fetching translation:', error);
      return field;  // Return the original field name in case of an error
    }
  }
  export const createTableRecord = async (endpoint, data) => {
    try {
      const token = getAccessToken(); // Получаем токен
      if (!token) {
        throw new Error('No access token available');
      }

      // Создание новой записи через API
      const response = await axios.post(
          `${API.BASE_URL}/${endpoint}`,
          { data },  // Передаем данные с уже загруженными ID файлов
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          }
      );

      return response.data;
    } catch (error) {
      console.error(`Error creating record in ${endpoint}:`, error);
      throw error;
    }
  };





  // Обновление записи в таблице
  export const updateTableRecord = async (endpoint, id, data) => {
    try {
      const token = getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }

      const response = await axios.put(`${API.BASE_URL}/${endpoint}/${id}`, { data }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      console.log('Данные успешно обновлены:', response.data);
      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении записи:', error.response ? error.response.data : error);
      throw new Error('Failed to update record');
    }
  };


  // Функция для получения схемы таблицы
  export const getTableSchema = async (endpoint) => {
    try {
      const token = getAccessToken(); // Получаем токен
      if (!token) {
        throw new Error('No access token available');
      }

      const response = await axios.get(API.getTableSchemaUrl(endpoint), {
        headers: {
          Authorization: `Bearer ${token}`,  // Используем токен для аутентификации
        },
      });
      return response.data; // Возвращаем атрибуты (схему)
    } catch (error) {
      console.error('Ошибка при получении схемы таблицы:', error);
      throw error;
    }
  };

  export const getTableName = async (endpoint) => {
    try {
      const token = getAccessToken(); // Получаем токен
      if (!token) {
        throw new Error('No access token available');
      }

      const response = await axios.get(`${API.BASE_URL}/table-schema/display-name/${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,  // Используем токен для аутентификации
        },
      });
      return response.data; // Возвращаем атрибуты (схему)
    } catch (error) {
      console.error('Ошибка при получении схемы таблицы:', error);
      throw error;
    }
  };

  // Экспорт всех данных для таблицы
  export const exportFullTableData = async (endpoint, populateFields = '*', format = 'word') => {
    try {
      const token = getAccessToken();
      if (!token) throw new Error('No access token available');

      const response = await axios.get(`${API.BASE_URL}/export/full`, {
        params: {
          table: endpoint,
          populateFields,
          format  // 👈 вот он
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      console.error(`Ошибка при экспорте всех данных из таблицы ${endpoint}:`, error);
      throw error;
    }
  };



  // Экспорт выбранных данных из таблицы
  export const exportSelectedTableData = async (endpoint, selectedIds, populateFields = '*', format = 'word') => {
    try {
      const token = getAccessToken();
      if (!token) throw new Error('No access token available');

      const response = await axios.post(`${API.BASE_URL}/export/selected`, {
        table: endpoint,
        ids: selectedIds,
        populateFields,
        format  // 👈 здесь
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      console.error(`Ошибка при экспорте выбранных данных из таблицы ${endpoint}:`, error.response || error);
      throw error;
    }
  };



  // Функция для загрузки файлов
  export const uploadFile = async (file) => {
      try {
          const token = getAccessToken();
          if (!token) {
              throw new Error('No access token available');
          }

          const formData = new FormData();
          formData.append('files', file);

          const response = await axios.post(`${API.BASE_URL}/upload`, formData, {
              headers: {
                  Authorization: `Bearer ${token}`
              },
          });

          if (response.data.length > 0) {
              return response.data[0]; // Возвращаем загруженный файл
          } else {
              throw new Error('File upload failed');
          }
      } catch (error) {
          console.error('Ошибка загрузки файла:', error);
          throw error;
      }
  };

